import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tab,
  Tabs,
} from "@mui/material";
import { Card } from "../components/ui/Card";
import { useEffect, useState } from "react";
import { GridRowModel } from "@mui/x-data-grid";
import { CustomDataTable, DatePickerEl } from "../components/ui/uiImport";
import {
  getAllCodRemittanceData,
  getAllInvoiceData,
  getAllPassbookData,
  getAllShipmentData,
  getAllWalletHistoryData,
} from "../config/api";
import dayjs, { Dayjs } from "dayjs";
import { NavigateToAwbOrder } from "../components/features/orders/OrderData";

export const shippingColumns = [
  {
    field: "shipment_id",
    headerName: "Shipment Id",
    minWidth: 50,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <NavigateToAwbOrder awbNo={params.row.shipment_id} />
      </>
    ),
  },
  {
    field: "awb_number",
    headerName: "Awb Number",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <p
          style={{
            color: "#3c8aca",
          }}
        >
          {params.row.awb_number}
        </p>
      </>
    ),
  },
  {
    field: "service",
    headerName: "Service",
    minWidth: 140,
    flex: 1,
  },

  {
    field: "shipment_status",
    headerName: "Shipment Status",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "booked_weight_charges",
    headerName: `Booked Weight Charges`,
    minWidth: 200,
    flex: 1,
  },
  {
    field: "excess_weight_charges",
    headerName: "Excess Weight Charges",
    minWidth: 200,
    flex: 1,
  },
  {
    field: "total_shipment_charges",
    headerName: "Total Shipment Charges",
    minWidth: 200,
    flex: 1,
  },
  {
    field: "booked_weight",
    headerName: "Booked Weight",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "charged_weight",
    headerName: "Charged Weight",
    minWidth: 140,
    flex: 1,
  },
];
export const codRemColumns = [
  {
    field: "awb_number",
    headerName: "Awb Number",
    minWidth: 140,
    flex: 1,
    renderCell: (params: { row: GridRowModel }) => (
      <>
        <p
          style={{
            color: "#3c8aca",
          }}
        >
          {params.row.awb_number}
        </p>
      </>
    ),
  },
  {
    field: "cod_amount",
    headerName: "Cod Amount",
    minWidth: 140,
    flex: 1,
  },

  {
    field: "cod_remitted",
    headerName: "Cod Remitted",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "remitted_date",
    headerName: `Remitted Date`,
    minWidth: 200,
    flex: 1,
  },
  {
    field: "status",
    headerName: `Status`,
    minWidth: 200,
    flex: 1,
  },
  {
    field: "shipment_delivery_date",
    headerName: "Shipment Track Time",
    minWidth: 200,
    flex: 1,
  },
];
export const invoiceColumns = [
  {
    field: "shipment_id",
    headerName: "Shipment Id",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "invoice_number",
    headerName: "Invoice Number",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "invoice_date",
    headerName: "Invoice Date",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "due_date",
    headerName: `Due Date`,
    minWidth: 200,
    flex: 1,
  },
  {
    field: "total",
    headerName: "Total",
    minWidth: 200,
    flex: 1,
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 200,
    flex: 1,
  },
];

export const walletHistoryColumns = [
  {
    field: "transaction_type",
    headerName: "Transcation Type",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "transaction_id",
    headerName: "Transaction Id",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "formatted_date",
    headerName: "Transcation On",
    minWidth: 140,
    flex: 1,
  },
];

export const passbookColumns = [
  {
    field: "shipment_id",
    headerName: "Shipment Id",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "awb_number",
    headerName: "Awb Number",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "catagory",
    headerName: "Category",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "credit_amount",
    headerName: "Credit Amount",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "debit_amount",
    headerName: "Debit Amount",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "description",
    headerName: "Description",
    minWidth: 140,
    flex: 1,
  },
  {
    field: "created",
    headerName: "Created On",
    minWidth: 140,
    flex: 1,
  },
];
const Billing = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [allShipmentData, setAllShipmentData] = useState<any>([]);
  const [page, setPage] = useState(1);

  const startDateConstant = dayjs().subtract(10, "day");
  const endDateConstant = dayjs();

  const [startDate, setStartDate] = useState<Dayjs | null>(startDateConstant);
  const [endDate, setEndDate] = useState<Dayjs | null>(endDateConstant);

  const handleDateChange = (time: Dayjs | null, type: string) => {
    if (type === "start") {
      setStartDate(time);
    } else {
      setEndDate(time);
    }
  };

  const [codType, setCodType] = useState("cod_remitted");

  useEffect(() => {
    setAllShipmentData([]);
    if (activeTab === 0) {
      getAllShipmentData(page, startDate as Dayjs, endDate as Dayjs)
        .then((data) => {
          const finalData = data?.data?.data as any;

          finalData?.data.map((el: any, index: number) => (el.id = index + 1));
          setAllShipmentData(finalData);
        })
        .catch((error) => console.log(error));
    }
    if (activeTab === 1) {
      getAllCodRemittanceData(
        page,
        startDate as Dayjs,
        endDate as Dayjs,
        codType
      )
        .then((data) => {
          const finalData = data?.data?.data as any;

          finalData?.data.map((el: any, index: number) => (el.id = index + 1));
          setAllShipmentData(finalData);
        })
        .catch((error) => console.log(error));
    }
    if (activeTab === 2) {
      getAllWalletHistoryData(startDate as Dayjs, endDate as Dayjs)
        .then((data) => {
          const finalData = data?.data?.data as any;

          finalData?.data.map((el: any, index: number) => (el.id = index + 1));
          setAllShipmentData(finalData);
        })
        .catch((error) => console.log(error));
    }
    if (activeTab === 3) {
      getAllInvoiceData(page, startDate as Dayjs, endDate as Dayjs)
        .then((data) => {
          const finalData = data?.data?.data as any;

          finalData?.data.map((el: any, index: number) => (el.id = index + 1));
          setAllShipmentData(finalData);
        })
        .catch((error) => console.log(error));
    }
    if (activeTab === 4) {
      getAllPassbookData(page, startDate as Dayjs, endDate as Dayjs)
        .then((data) => {
          const finalData = data?.data?.data as any;

          finalData?.data.map((el: any, index: number) => (el.id = index + 1));
          setAllShipmentData(finalData);
        })
        .catch((error) => console.log(error));
    }
  }, [activeTab, page, startDate, endDate, codType]);

  const updatePage = (event: React.ChangeEvent<unknown>, page: number) => {
    event.preventDefault();
    setPage(page);
  };

  return (
    <Card>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Stack flexDirection={"row"} gap={"20px"}>
          <DatePickerEl
            defaultDate={startDate}
            handleChange={(time) => handleDateChange(time, "start")}
            label="From"
          />
          <DatePickerEl
            defaultDate={endDate}
            handleChange={(time) => handleDateChange(time, "end")}
            label="To"
          />
        </Stack>
        <Tabs
          value={activeTab}
          onChange={(e: React.SyntheticEvent<Element, Event>, value: any) =>
            setActiveTab(value)
          }
          variant="scrollable"
        >
          <Tab label="Shipping Charges" value={0} />
          <Tab label="COD Remittance" value={1} />
          <Tab label="Wallet History" value={2} />
          <Tab label="Invoices" value={3} />
          <Tab label="Passbook" value={4} />
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <>
          <Stack
            marginTop={"20px"}
            flexDirection={"row"}
            width={"100%"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={"20px"}
          >
            <Card
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>
                Total Freight Charges: Rs.{" "}
                {allShipmentData?.total_fright_charges}
              </p>
            </Card>
            <Card
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>
                Billed Freight Charges: Rs.{" "}
                {allShipmentData?.billed_fright_charges}
              </p>
            </Card>
            <Card
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>
                Unbilled Freight Charges: Rs.{" "}
                {allShipmentData?.unbilled_fright_charges}
              </p>
            </Card>
          </Stack>

          <Box marginTop={"20px"}>
            <CustomDataTable
              total={allShipmentData?.shipment_count}
              totalRow={allShipmentData?.page_count}
              rows={allShipmentData?.data ?? []}
              columns={shippingColumns}
              updatePage={updatePage}
              page={page}
            />
          </Box>
        </>
      )}
      {activeTab === 1 && (
        <>
          <Box margin={"20px 0px"} sx={{ float: "right" }}>
            <FormControl sx={{ minWidth: 150 }} size="small">
              <InputLabel id="demo-select-small-label">COD Type</InputLabel>
              <Select
                sx={{
                  width: "100%",
                }}
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={codType}
                label="COD Type"
                onChange={(e) => setCodType(e.target.value)}
              >
                <MenuItem value={"future_cod"}>Future Cod</MenuItem>
                <MenuItem value={"cod_remitted"}>Cod Remitted</MenuItem>
              </Select>
            </FormControl>
          </Box>


          <Stack
            marginTop={"20px"}
            flexDirection={"row"}
            width={"100%"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={"20px"}
          >
            <Card
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>Last Cod Amt: Rs. {allShipmentData?.last_cod_amt}</p>
            </Card>
            <Card
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>
                Cod To be Remitted Amt: Rs.{" "}
                {allShipmentData?.cod_tobe_remitted_amt}
              </p>
            </Card>
            <Card
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>Total Cod Amt: Rs. {allShipmentData?.total_cod_amt}</p>
            </Card>
          </Stack>


          <Box marginTop={"20px"}>
            <CustomDataTable
              total={allShipmentData?.shipment_count}
              totalRow={allShipmentData?.page_count}
              rows={allShipmentData?.data ?? []}
              columns={codRemColumns}
              updatePage={updatePage}
              page={page}
            />
          </Box>
        </>
      )}
      {activeTab === 2 && (
        <>
          <Box marginTop={"20px"}>
            <CustomDataTable
              total={allShipmentData?.shipment_count}
              totalRow={allShipmentData?.page_count}
              rows={allShipmentData?.data ?? []}
              columns={walletHistoryColumns}
              updatePage={updatePage}
              page={page}
            />
          </Box>
        </>
      )}
      {activeTab === 3 && (
        <>
          <Box marginTop={"20px"}>
            <CustomDataTable
              total={allShipmentData?.shipment_count}
              totalRow={allShipmentData?.page_count}
              rows={allShipmentData?.data ?? []}
              columns={invoiceColumns}
              updatePage={updatePage}
              page={page}
            />
          </Box>
        </>
      )}

      {activeTab === 4 && (
        <>
          <Stack
            marginTop={"20px"}
            flexDirection={"row"}
            width={"100%"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={"20px"}
          >
            <Card
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>
                Total Useable Bal: Rs. {allShipmentData?.current_usable_bal}
              </p>
            </Card>
            <Card
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>Total On Hold Bal: Rs. {allShipmentData?.on_hold_bal}</p>
            </Card>
            <Card
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p>Total Bal: Rs. {allShipmentData?.total_bal}</p>
            </Card>
          </Stack>
          <Box marginTop={"20px"}>
            <CustomDataTable
              total={allShipmentData?.shipment_count}
              totalRow={allShipmentData?.page_count}
              rows={allShipmentData?.data ?? []}
              columns={passbookColumns}
              updatePage={updatePage}
              page={page}
            />
          </Box>
        </>
      )}
    </Card>
  );
};

export default Billing;
